var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9121 4.48351C14.4725 4.48351 17.3406 7.35164 17.3406 10.9121C17.3406 14.4725 14.4725 17.3406 10.9121 17.3406C7.35164 17.3406 4.48351 14.4725 4.48351 10.9121C4.48351 7.35164 7.35164 4.48351 10.9121 4.48351ZM10.9121 3C6.56043 3 3 6.56043 3 10.9121C3 15.2637 6.56043 18.8241 10.9121 18.8241C15.2637 18.8241 18.8241 15.2637 18.8241 10.9121C18.8241 6.56043 15.2637 3 10.9121 3Z",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3077 19.3187L15.956 14.967L15.4615 15.4615C15.1648 15.7583 15.1648 16.2528 15.4615 16.6484L19.8132 21L20.3077 20.5055C20.7033 20.2088 20.7033 19.6154 20.3077 19.3187Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.763746cf057ff79c5bdd5eafcac331d6.svg";
export { ForwardRef as ReactComponent };